module.exports = __webpack_public_path__ + "img/1-2.07bc09f8.png";